import { useRef, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FONTS } from "@/lib/poster";

const FontSample = ({ f, sample, italic, testId }) => (
  <span dir="auto" data-testid={testId} className="block whitespace-normal [overflow-wrap:anywhere] px-1 py-1 leading-[1.6]" style={{ fontFamily: `"${f.family}"`, fontWeight: f.weight, fontSize: f.script ? 24 : 17, fontStyle: italic ? "italic" : "normal" }}>
    {sample?.trim() || f.name}
  </span>
);

export const FontSelect = ({ label, value, onChange, testId, sample, italic }) => {
  const trigger = useRef(null);
  const [placement, setPlacement] = useState({ side: "bottom", maxHeight: 384 });
  const positionMenu = (open) => {
    if (!open || !trigger.current) return;
    const rect = trigger.current.getBoundingClientRect();
    const styles = getComputedStyle(document.documentElement);
    // Shopify's iframe is much taller than the visible parent screen.
    const top = parseFloat(styles.getPropertyValue("--ms-scroll")) || 0;
    const height = parseFloat(styles.getPropertyValue("--ms-vh")) || window.innerHeight;
    const below = Math.max(0, top + height - rect.bottom - 16);
    const above = Math.max(0, rect.top - top - 16);
    const side = below >= Math.min(384, height * 0.6) || below >= above ? "bottom" : "top";
    setPlacement({ side, maxHeight: Math.min(384, height * 0.6, side === "bottom" ? below : above) });
  };

  return (
    <div className="min-w-0 space-y-2">
      <span id={`${testId}-label`} className="text-xs uppercase tracking-[0.18em] text-[#9A8C7D]">{label}</span>
      <Select value={value} onValueChange={onChange} onOpenChange={positionMenu}>
        <SelectTrigger ref={trigger} aria-labelledby={`${testId}-label`} className="font-select-trigger h-auto min-h-12 gap-2 rounded-xl bg-white border-[#CDC0B0]" data-testid={testId}>
          <SelectValue>
            <FontSample f={FONTS.find((f) => f.id === value) || FONTS[0]} sample={sample} italic={italic} testId={`${testId}-selected-sample`} />
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="font-select-menu" side={placement.side} avoidCollisions={false} style={{ maxHeight: placement.maxHeight }} data-testid={`${testId}-menu`}>
          {FONTS.map((f) => (
            <SelectItem key={f.id} value={f.id} textValue={f.name} className="font-select-option" data-testid={`${testId}-option-${f.id}`}>
              <span className="flex min-w-0 flex-col py-1">
                <FontSample f={f} sample={sample} italic={italic} testId={`${testId}-sample-${f.id}`} />
                <span className="whitespace-normal [overflow-wrap:anywhere] text-[10px] uppercase tracking-wider text-[#9A8C7D]" data-testid={`${testId}-name-${f.id}`}>{f.name}</span>
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
